import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export const WEBHOOK_EVENTS = [
  'employee.created',
  'employee.updated',
  'employee.terminated',
  'employee.deleted',
  'payroll.calculated',
  'document.signed',
  'approval.completed',
] as const;
export type WebhookEvent = typeof WEBHOOK_EVENTS[number];

export interface Webhook {
  id: string;
  url: string;
  events: string[];
  description: string | null;
  /** Only present on create response. */
  secret?: string;
  createdBy: string | null;
  createdAt: string;
  lastDeliveryAt: string | null;
  lastDeliveryStatus: number | null;
  lastDeliveryError: string | null;
  disabledAt: string | null;
}

export function useWebhooks() {
  return useQuery({
    queryKey: ['webhooks'],
    queryFn: async () => {
      const r = await api.get<{ webhooks: Webhook[] }>('/api/webhooks');
      return r.data.webhooks;
    },
  });
}

export function useCreateWebhook() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { url: string; events: string[]; description?: string }) => {
      const r = await api.post<Webhook>('/api/webhooks', input);
      return r.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['webhooks'] }),
  });
}

export function useDisableWebhook() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/api/webhooks/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['webhooks'] }),
  });
}
